import { AggregationTranslation } from '@/types/virtual-search/filters';
import { HblEntity } from '@/types/hbl/hbl.entity';
import i18n from '@/i18n';

export const HblVirtualFilterTranslation = (): AggregationTranslation<HblEntity> => ({
  // @ts-ignore
  'outPackageType.description.keyword': {
    type: 'select',
    label: 'Out Package Type',
    value: 'outPackageType.description.keyword',
  },
  isAutoItNumber: {
    type: 'boolean',
    label: 'Is Auto IT #',
    value: 'isAutoItNumber',
  },
  cargoHold: {
    type: 'boolean',
    label: 'Cargo Hold',
    value: 'cargoHold',
  },
  'coLoader.accountName.keyword': {
    type: 'select',
    label: 'Co-Loader',
    value: 'coLoader.accountName.keyword',
  },
  isConsolidated: {
    type: 'boolean',
    label: 'Consolidated',
    value: 'isConsolidated',
  },
  customReleased: {
    type: 'boolean',
    label: 'Custom Released',
    value: 'customReleased',
  },
  'customer.accountName.keyword': {
    type: 'select',
    label: 'Customer',
    value: 'customer.accountName.keyword',
  },
  customerCommissionProcessed: {
    type: 'boolean',
    label: 'Customer Commission Processed',
    value: 'customerCommissionProcessed',
  },
  nonCommissionable: {
    type: 'boolean',
    label: i18n.tc('NonCommissionable'),
    value: 'nonCommissionable',
  },
  deliveryOrder: {
    type: 'boolean',
    label: 'Delivery Order',
    value: 'deliveryOrder',
  },
  domesticMove: {
    type: 'boolean',
    label: 'Domestic Move',
    value: 'domesticMove',
  },
  doorDelivery: {
    type: 'boolean',
    label: 'Door Delivery',
    value: 'doorDelivery',
  },
  isDueCargo: {
    type: 'boolean',
    label: 'Due Cargo',
    value: 'isDueCargo',
  },
  'entryType.description.keyword': {
    type: 'select',
    label: 'Entry Type',
    value: 'entryType.description.keyword',
  },
  isExchangePalletResolved: {
    type: 'boolean',
    label: 'Exchange Pallet Resolved',
    value: 'isExchangePalletResolved',
  },
  'facility.description.keyword': {
    type: 'select',
    label: 'Facility',
    value: 'facility.description.keyword',
  },
  'fileSource.keyword': {
    type: 'select',
    label: 'File Source',
    value: 'fileSource.keyword',
  },
  frieghtReleased: {
    type: 'boolean',
    label: 'Freight Released',
    value: 'frieghtReleased',
  },
  hazardous: {
    type: 'boolean',
    label: 'Hazardous',
    value: 'hazardous',
  },
  headLoad: {
    type: 'boolean',
    label: 'Head Load',
    value: 'headLoad',
  },
  isIpi: {
    type: 'boolean',
    label: 'IPI',
    value: 'isIpi',
  },
  loadHold: {
    type: 'boolean',
    label: 'Load Hold',
    value: 'loadHold',
  },
  isLoaded: {
    type: 'boolean',
    label: 'Loaded',
    value: 'isLoaded',
  },
  'manifestedPackageType.description.keyword': {
    type: 'select',
    label: 'Manifested Package Type',
    value: 'manifestedPackageType.description.keyword',
  },
  markHold: {
    type: 'boolean',
    label: 'Mark Hold',
    value: 'markHold',
  },
  isMarkReleased: {
    type: 'boolean',
    label: 'Mark Released',
    value: 'isMarkReleased',
  },
  'onFwd.description.keyword': {
    type: 'select',
    label: 'On FWD',
    value: 'onFwd.description.keyword',
  },
  'paymentLookup.description.keyword': {
    type: 'select',
    label: 'Payment Lookup',
    value: 'paymentLookup.description.keyword',
  },
  isPickupReceiptPrinted: {
    type: 'boolean',
    label: 'Pickup Receipt Printed',
    value: 'isPickupReceiptPrinted',
  },
  'pod.description.keyword': {
    type: 'select',
    label: 'POD',
    value: 'pod.description.keyword',
  },
  'receivedPackageType.description.keyword': {
    type: 'select',
    label: 'Received Package Type',
    value: 'receivedPackageType.description.keyword',
  },
  'service.keyword': {
    type: 'select',
    label: 'Service',
    value: 'service.keyword',
  },
  'status.keyword': {
    type: 'select',
    label: 'Status',
    value: 'status.keyword',
  },
  'warehouse.accountName.keyword': {
    type: 'select',
    label: 'Warehouse',
    value: 'warehouse.accountName.keyword',
  },
  warehouseCollectCommissionProcessed: {
    type: 'boolean',
    label: 'Warehouse Collect Commission Processed',
    value: 'warehouseCollectCommissionProcessed',
  },
});

export const InventoryVirtualFilterTranslation = (): AggregationTranslation<HblEntity> => ({
  // @ts-ignore
  'outPackageType.description.keyword': {
    type: 'select',
    label: 'Out Package Type',
    value: 'outPackageType.description.keyword',
  },
  isAutoItNumber: {
    type: 'boolean',
    label: 'Is Auto IT #',
    value: 'isAutoItNumber',
  },
  cargoHold: {
    type: 'boolean',
    label: 'Cargo Hold',
    value: 'cargoHold',
  },
  'coLoader.accountName.keyword': {
    type: 'select',
    label: 'Co-Loader',
    value: 'coLoader.accountName.keyword',
  },
  isConsolidated: {
    type: 'boolean',
    label: 'Consolidated',
    value: 'isConsolidated',
  },
  customReleased: {
    type: 'boolean',
    label: 'Custom Released',
    value: 'customReleased',
  },
  'customer.accountName.keyword': {
    type: 'select',
    label: 'Customer',
    value: 'customer.accountName.keyword',
  },
  customerCommissionProcessed: {
    type: 'boolean',
    label: 'Customer Commission Processed',
    value: 'customerCommissionProcessed',
  },
  nonCommissionable: {
    type: 'boolean',
    label: i18n.tc('NonCommissionable'),
    value: 'nonCommissionable',
  },
  deliveryOrder: {
    type: 'boolean',
    label: 'Delivery Order',
    value: 'deliveryOrder',
  },
  domesticMove: {
    type: 'boolean',
    label: 'Domestic Move',
    value: 'domesticMove',
  },
  doorDelivery: {
    type: 'boolean',
    label: 'Door Delivery',
    value: 'doorDelivery',
  },
  isDueCargo: {
    type: 'boolean',
    label: 'Due Cargo',
    value: 'isDueCargo',
  },
  'entryType.description.keyword': {
    type: 'select',
    label: 'Entry Type',
    value: 'entryType.description.keyword',
  },
  isExchangePalletResolved: {
    type: 'boolean',
    label: 'Exchange Pallet Resolved',
    value: 'isExchangePalletResolved',
  },
  'facility.description.keyword': {
    type: 'select',
    label: 'Facility',
    value: 'facility.description.keyword',
  },
  'fileSource.keyword': {
    type: 'select',
    label: 'File Source',
    value: 'fileSource.keyword',
  },
  frieghtReleased: {
    type: 'boolean',
    label: 'Freight Released',
    value: 'frieghtReleased',
  },
  hazardous: {
    type: 'boolean',
    label: 'Hazardous',
    value: 'hazardous',
  },
  headLoad: {
    type: 'boolean',
    label: 'Head Load',
    value: 'headLoad',
  },
  isIpi: {
    type: 'boolean',
    label: 'IPI',
    value: 'isIpi',
  },
  loadHold: {
    type: 'boolean',
    label: 'Load Hold',
    value: 'loadHold',
  },
  isLoaded: {
    type: 'boolean',
    label: 'Loaded',
    value: 'isLoaded',
  },
  'manifestedPackageType.description.keyword': {
    type: 'select',
    label: 'Manifested Package Type',
    value: 'manifestedPackageType.description.keyword',
  },
  markHold: {
    type: 'boolean',
    label: 'Mark Hold',
    value: 'markHold',
  },
  isMarkReleased: {
    type: 'boolean',
    label: 'Mark Released',
    value: 'isMarkReleased',
  },
  'onFwd.description.keyword': {
    type: 'select',
    label: 'On FWD',
    value: 'onFwd.description.keyword',
  },
  'paymentLookup.description.keyword': {
    type: 'select',
    label: 'Payment Lookup',
    value: 'paymentLookup.description.keyword',
  },
  isPickupReceiptPrinted: {
    type: 'boolean',
    label: 'Pickup Receipt Printed',
    value: 'isPickupReceiptPrinted',
  },
  'pod.description.keyword': {
    type: 'select',
    label: 'POD',
    value: 'pod.description.keyword',
  },
  'receivedPackageType.description.keyword': {
    type: 'select',
    label: 'Received Package Type',
    value: 'receivedPackageType.description.keyword',
  },
  'service.keyword': {
    type: 'select',
    label: 'Service',
    value: 'service.keyword',
  },
  'status.keyword': {
    type: 'select',
    label: 'Status',
    value: 'status.keyword',
  },
  // 'warehouse.accountName.keyword': {
  //   type: 'select',
  //   label: 'Warehouse',
  //   value: 'warehouse.accountName.keyword',
  // },
  warehouseCollectCommissionProcessed: {
    type: 'boolean',
    label: 'Warehouse Collect Commission Processed',
    value: 'warehouseCollectCommissionProcessed',
  },
});

export const HblVirtualFilterAdditionalOption = (): AggregationTranslation<HblEntity> => ({
  // @ts-ignore
  isGoEligible: {
    type: 'boolean',
    label: 'Eligible for GO',
    value: 'isGoEligible',
  },
  nonCommissionable: {
    type: 'boolean',
    label: i18n.tc('NonCommissionable'),
    value: 'nonCommissionable',
  },
  // commodity: {
  //   type: 'text',
  //   label: 'Commodity',
  //   value: 'description',
  // },
  unArrivedITs: {
    type: 'boolean',
    label: 'Un-arrived IT',
    value: 'unArrivedITs',
  },
  trackingNumber: {
    type: 'text',
    label: 'Tracking #',
    value: 'trackingNumber',
  },
  shipmentNumber: {
    type: 'text',
    label: 'Shipment #',
    value: 'shipmentNumber',
  },
  mblNumber: {
    type: 'text',
    label: 'MBL #',
    value: 'mblNumber',
  },
  marks: {
    type: 'text',
    label: 'Marks',
    value: 'marks',
  },
  loadPlanNumber: {
    type: 'text',
    label: 'Load Plan #',
    value: 'loadPlanNumber',
  },
  loadGuideNumber: {
    type: 'text',
    label: 'Load Guide #',
    value: 'loadGuideNumber',
  },
  itNumber: {
    type: 'text',
    label: 'IT #',
    value: 'itNumber',
  },
  load: {
    type: 'text',
    label: 'Load #',
    value: 'load',
  },
  inventoryLocation: {
    type: 'text',
    label: 'Inventory Location',
    value: 'inventoryLocation',
  },
  consignee: {
    type: 'text',
    label: 'Consignee',
    value: 'consignee',
  },
  containerNumber: {
    type: 'text',
    label: 'Container #',
    value: 'containerNumber',
  },
  customerRef: {
    type: 'text',
    label: 'Customer Reference',
    value: 'customerRef',
  },
  driver: {
    type: 'text',
    label: 'Driver',
    value: 'driver',
  },
  driverLicense: {
    type: 'text',
    label: 'Driver License',
    value: 'driverLicense',
  },
  emergencyContactNumber: {
    type: 'text',
    label: 'Emergency Contact #',
    value: 'emergencyContactNumber',
  },
  entryNumber: {
    type: 'text',
    label: 'Entry #',
    value: 'entryNumber',
  },
  goNumber: {
    type: 'text',
    label: 'GO #',
    value: 'goNumber',
  },
  hblNumber: {
    type: 'text',
    label: 'HBL #',
    value: 'hblNumber',
  },
  amsHblNumber: {
    type: 'text',
    label: 'AMS HBL #',
    value: 'amsHblNumber',
  },
  broker: {
    type: 'text',
    label: 'Broker',
    value: 'broker',
  },
  deliverTo: {
    type: 'text',
    label: 'Deliver To',
    value: 'deliverTo',
  },
  releaseTo: {
    type: 'text',
    label: 'Release To',
    value: 'releaseTo',
  },
  releasedBy: {
    type: 'text',
    label: 'Released By',
    value: 'releasedBy',
  },
  shipper: {
    type: 'text',
    label: 'Shipper',
    value: 'shipper',
  },
  customReleasedBy: {
    type: 'text',
    label: 'Custom Released By',
    value: 'customReleasedBy',
  },
  truckerName: {
    type: 'text',
    label: 'Trucker Name',
    value: 'truckerName',
  },
  itDate: {
    type: 'date',
    label: 'IT Submitted Date',
    value: 'itDate',
  },
  itApprovalDate: {
    type: 'date',
    label: 'IT Approved Date',
    value: 'itApprovalDate',
  },
  availableDate: {
    type: 'date',
    label: 'Available Date',
    value: 'availableDate',
  },
  goDate: {
    type: 'date',
    label: 'GO Date',
    value: 'goDate',
  },
  loadDate: {
    type: 'date',
    label: 'IPI Load Date',
    value: 'loadDate',
  },
  eta: {
    type: 'date',
    label: 'IPI ETA',
    value: 'eta',
  },
  arrivalDate: {
    type: 'date',
    label: 'IPI ATA',
    value: 'arrivalDate',
  },
  shipDate: {
    type: 'date',
    label: 'IPI DEPARTURE DATE',
    value: 'shipDate',
  },
  lfd: {
    type: 'date',
    label: 'Last Free Date',
    value: 'lfd',
  },
  deliveryReleasedDate: {
    type: 'date',
    label: 'Released Date',
    value: 'deliveryReleasedDate',
  },
  readyForPickupDate: {
    type: 'date',
    label: 'Ready For Pickup',
    value: 'readyForPickupDate',
  },
});

export const HblVirtualFilterDefaultForm = () => ({
  'status.keyword': [],
});

export const InventoryVirtualFilterDefaultForm = (defaults: string[] = []) => ({
  'warehouse.id': defaults,
});
